// src/utils/recentlyViewed.js
// Suivi des annonces consultées récemment (localStorage) - NE PAS MODIFIER

const STORAGE_KEY = 'fynho_recently_viewed';
const MAX_ITEMS = 10;

export const addRecentlyViewed = (listing) => {
  if (!listing || !listing.id) return;

  try {
    const current = getRecentlyViewed();
    // Retire l'annonce si elle existe déjà (pour la remettre en tête de liste)
    const filtered = current.filter((l) => l.id !== listing.id);
    const updated = [
      {
        id: listing.id,
        slug: listing.slug,
        title: listing.title,
        quartier: listing.quartier,
        city: listing.city,
        price: listing.price,
        priceType: listing.price_type || listing.priceType,
        images: listing.images,
        category: listing.category,
      },
      ...filtered,
    ].slice(0, MAX_ITEMS);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (error) {
    // localStorage indisponible (navigation privée, etc.) → on ignore silencieusement
  }
};

export const getRecentlyViewed = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
};

export const clearRecentlyViewed = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // ignore
  }
};